import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SingleResponseModel, TabSystemMenuDto } from '../../models/base/base';
import { BaseHttpService } from '../base/base-http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserMenuService extends BaseHttpService<TabSystemMenuDto> {
  baseUrl = environment.baseUrl + this.getResourceUrl();
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getResourceUrl(): string {
    return 'TABSystemMenu';
  }

   get(id: any): Observable<SingleResponseModel<TabSystemMenuDto>> {
      let params = { id: id };
      return this.httpClient.get<SingleResponseModel<TabSystemMenuDto>>(`${this.baseUrl}/Getbyid`, { params: params });
    }
}
